module.exports = __webpack_public_path__ + "img/marker-danger.svg?65f2e63f121f1b51b6f65ef1fde93ace";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maps/marker-danger.svg
// module id = 298
// module chunks = 0